import React, { useState } from 'react';
import QRCode from "react-qr-code";
import { commonOverlayStyle } from './StatusOverlays/overlayStyles';
import ProctoringSetupGuide from '../../../components/ProctoringSetupGuide';
import { useWebSocket } from '../../../WebSocketContext';
import logger from './../../../utils/logger.js';



const ProctoringModal = ({
  socketData,
  isProctoringEnabled,
  isSecondryCameraJoined,
  surroundingRecorded,
  cameraPlaced,
  setProctoringEnabled,
  setSecondryCameraJoined,
  isProctoringResetup
}) => {
  const [status, setStatus] = useState("Surrounding Recorded");
  const [showLegacyUI, setShowLegacyUI] = useState(false);
  const { ws } = useWebSocket();


  if (!isProctoringEnabled) {

    return null;
  }

  const sendProctoringEvent = (eventType) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      const message = {
        type: "client_event",
        message: eventType,
        timestamp: new Date().toISOString()
      };
      logger.debug(`Sending proctoring event: ${eventType}`);
      ws.send(JSON.stringify(message));
      return true;
    } else {
      logger.warn(`WebSocket not connected for sending ${eventType} event`);
      return false;
    }
  };

  const handleButtonClick = () => {
    if (status === "Surrounding Recorded") {
      surroundingRecorded();
      sendProctoringEvent("proctoring_360_scan_complete");
      setStatus("Camera Placed");
    } else {
      cameraPlaced();
      sendProctoringEvent("proctoring_camera_placement_complete");
      setProctoringEnabled(false);
      setSecondryCameraJoined(false);
    }
  };

  // Handle completion of proctoring setup
  const handleProctoringComplete = () => {
    // Send all necessary events
    sendProctoringEvent("proctoring_setup_complete");
    surroundingRecorded();
    sendProctoringEvent("proctoring_360_scan_complete");
    cameraPlaced();
    sendProctoringEvent("proctoring_camera_placement_complete");
    setProctoringEnabled(false);
    setSecondryCameraJoined(false);
  };

  // Handle QR scan complete
  const handleQRScanComplete = () => {
    sendProctoringEvent("proctoring_qr_scan_complete");
  };

  // Handle SMS sending (placeholder function)
  const handleSendSMS = (phoneNumber) => {
    logger.debug(`SMS link would be sent to: ${phoneNumber}`);
    sendProctoringEvent("proctoring_sms_link_sent");
    // Implement actual SMS sending functionality here
    alert(`Link would be sent to ${phoneNumber} (not implemented)`);
  };

  return (
    <div style={commonOverlayStyle}>
      <div style={{ 
        backgroundColor: '#fff', 
        padding: '20px 40px', 
        borderRadius: 12, 
        color: '#000',
        maxWidth: '600px',
        width: '100%'
      }}>
        {showLegacyUI ? (
          // Legacy UI
          <>
            <p style={{ color: '#000', fontWeight: '500', fontSize: 16 }}>
              Please scan the QR code below to join the interview.
            </p>
            <ol style={{ color: 'gray', fontSize: 14 }}>
              <li>1. Ensure your microphone and speaker are muted for optimal sound quality.</li>
              <li>2. Be in a quiet environment for the best experience.</li>
              <li>3. After scanning, you will be able to see a 360-degree view of the room.</li>
            </ol>
            <div style={{ 
              display: 'flex', 
              margin: 'auto', 
              backgroundColor: '#fff', 
              height: 200, 
              width: 200, 
              borderRadius: 12, 
              padding: 12, 
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.8)', 
              marginTop: 20, 
              marginBottom: 20 
            }}>
              <QRCode
                style={{ height: 'auto', maxWidth: "100%", width: "100%" }}
                value={`${window.location.origin}/proctoring?roomUrl=${socketData?.side_camera_url}`}
                // value={`https://a3bb-14-99-245-66.ngrok-free.app/proctoring?roomUrl=${socketData?.side_camera_url}`}
                viewBox={`0 0 256 256`}
                onLoad={() => sendProctoringEvent("proctoring_qr_code_displayed")}
              />
            </div>

            {/* Display the button after camera joined */}
            {isSecondryCameraJoined && (
              <button 
                onClick={handleButtonClick} 
                style={{
                  padding: '4px 16px', 
                  backgroundColor: '#007bff', 
                  color: '#fff', 
                  borderRadius: 8, 
                  display: 'flex', 
                  margin: 'auto' 
                }}
              >
                {status}
              </button>
            )}
          </>
        ) : (
          // New UI with ProctoringSetupGuide
          <ProctoringSetupGuide 
            roomUrl={socketData?.side_camera_url || ''} 
            onComplete={handleProctoringComplete}
            onSendSMS={handleSendSMS}
            isSecondryCameraJoined={isSecondryCameraJoined}
            isProctoringEnabled={isProctoringEnabled}
            onQRScanComplete={handleQRScanComplete}
            isProctoringResetup={isProctoringResetup}
            initialStep={isProctoringResetup ? 0 : undefined}
          />
        )}
      </div>
    </div>
  );
};

export default ProctoringModal;